import axios from 'axios';

export const PROMOTION_METHODS_RECEIVED = 'PROMOTION_METHODS_RECEIVED';

const getPromotionMethods = () => (
  (dispatch) => {
    axios.get('/api/product-management/promotion-methods')
      .then((response) => {
        dispatch({
          type: PROMOTION_METHODS_RECEIVED,
          promotionMethods: response.data.data,
        });
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location = '/login';
        }
      });
  }
);

export default getPromotionMethods;
